import { Route, Redirect } from "react-router-dom";
import { getValue } from "../auth";

function ProtectedRouteSupport({ children, ...rest }: any) {
  let auth: boolean = Boolean(getValue("isSupportLogged"));
  return (
    <Route
      {...rest}
      render={({ location }) =>
        auth ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/support/login",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

export default ProtectedRouteSupport;
